module.exports = __webpack_public_path__ + "img/avatar-david.fda2ae89.png";